const angular = require('angular');
const app = angular.module('learn-services');
const moment = require('moment');

// const FullStory = require('@fullstory/browser');
// const LogRocket = require('logrocket')
import createLog from 'localstorage-logger';

/**
 * Constant values and global singleton services for the learn app Application
 * @argument {$cookies} $cookies injected to get and set cookies
 * @argument {$timeout} $timeout injected to call timout with addition to call "flush" and "verifyNoPendingTasks" methods.
 * @argument {$location} $location injected to get and set routes url etc
 * @argument {$window} $window injected to get access to window element
 * @argument {$routeParams} $routeParams object that holds the  route parameters defined in the $routeProvider object
 * @argument {$translate} $translate The angular-translate service
 */
app.factory('Application', ['$location', '$timeout', '$window', '$rootScope', 'appConfiguration', 'Access', 'AnalyticsProvider', 'Features', 'Intercom', 'Languages', 'Messaging', 'Navigation', 'NotificationService', 'Storage', function($location, $timeout, $window, $rootScope, appConfiguration, Access, AnalyticsProvider, Features, Intercom, Languages, Messaging, Navigation, NotificationService, Storage) {
    var self = this;

    const log = createLog({
      logName: 'continu-learn-app',
      maxLogSizeInBytes: 500 * 1024
    });
    window.continuAppLog = log;

    const logWithStack = (typ, message, ...addl) => {
      var e = new Error('dummy');
      var stack = e.stack.replace(/^[^\(]+?[\n$]/gm, '')
          .replace(/^\s+at\s+/gm, '')
          .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@')
          .split('\n');
      console.trace(message, addl);
      log.warn(message, { addl: addl});
    };

    
    self.scrollTop = function() {
      $window.scrollTo(0, 0);
    };

    /**
     * Smartbar control object
     */
    self.smartbar = {
      showcategories: false,
      showsearch: false,
      searchText: '',
      placeholder: 'What are you looking for?',
      setPlaceholder: function(text) {
        self.smartbar.placeholder = text;
      },
      getSearchText: function() {
        return self.smartbar.searchText;
      },
      showCategories: function() {
        self.smartbar.showcategories = true;
      },
      hideCategories: function() {
        self.smartbar.showcategories = false;
      },
      showSearch: function() {
        self.smartbar.showsearch = true;
      },
      hideSearch: function() {
        self.smartbar.showsearch = false;
      },
      share: {
        open: false,
        toggle: function() {
          self.smartbar.share.open = !self.smartbar.share.open;
        }
      }
    };
    

    $rootScope.$on('$locationChangeSuccess', function(event, newUrl, oldUrl) {
      if (newUrl && newUrl.indexOf('?')) {
        newUrl = newUrl.split('?')[0];
      }
      if (newUrl.indexOf('saml-transition') !== -1 || newUrl.indexOf('oauth-transition') !== -1) {
        return;
      }
      Navigation.history.push(newUrl);
    });

    /**
     * Content visual hooks
     */
    self.visual = {};    
    /**
     * Categories control object
     */
    self.categories = {
      set: function(id) {
        Storage.put('category', {
          _id: id,
          ttl: new Date().valueOf() + 1800000
        });
      },
      get: function() {
        var item = Storage.get('category');
        if (!item) {
          return null;
        }
        if (!item.ttl || item.ttl < new Date().valueOf() || !item._id) {
          Storage.remove('category');
          return null;
        }
        Storage.remove('category');
        return item._id;
      }
    };
    /**
     * TrackState control object
     */
    // State must containt the content type in question as well as a track Id (as track)
    self.trackState = {
      state: Storage.get('reactTrackState')?.state?.trackState || null,
      set: function(item) {
        this.state = item;

        // ! To be used by React application
        Storage.put('trackState', item);

        if (item === null) {
          Storage.remove('reactTrackState');
        }
      },
      get: function() {
        return this.state;
      }
    };

    self.Tracking = function(analyze, moment, type, track) {
      this.lastId = null;
      this.startTime = null;
      this.initialPosition = null;
      this.furthestPosition = null;
      this.track = track || null;
      this.contentType = type;
      this.setInitialPosition = function(progress) {
        this.initialPosition = progress;
      };
      this.setTrackId = function(id) {
        this.track = id;
      };
      this.checkFurthest = function(progress) {
        if (!this.furthestPosition || progress > this.furthestPosition) {
          this.furthestPosition = progress;
        }
      };
      this.start = function(item) {
        if (this.startTime) {
          this.end(true, item);
          return;
        }
        this.lastId = item._id;
        this.startTime = new Date();
      };
      this.end = function(restart, item) {
        if (!this.startTime || !this.lastId) {
          return;
        }
        var timeSpent = moment(new Date()).diff(moment(this.startTime), 'seconds');
        var data = {content: this.lastId, duration: timeSpent};
        if (this.initialPosition || this.initialPosition === 0) {
          data.start_position = this.initialPosition;
        }
        if (this.furthestPosition) {
          data.furthest_position = this.furthestPosition;
        }
        if (this.contentType) {
          data.content_type = this.contentType;
        }
        if (this.track) {
          data.track_context = this.track;
        }
        analyze.record({resource: 'content-session'}, data).$promise.then(function(item) {});
        this.lastId = null;
        this.startTime = null;
        this.initialPosition = null;
        this.furthestPosition = null;
        if (restart && item) {
          this.start(item);
        }
      };
    };
 
    
    self.defer = function(_function, milliseconds) {
      $timeout(_function, milliseconds);
    };
    self.getBrowser = function() {
      var browser = 'unknown';
      // Opera 8.0+
      // Opera 8.0+
      var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

      // Firefox 1.0+
      var isFirefox = typeof InstallTrigger !== 'undefined';

      // Safari 3.0+ "[object HTMLElementConstructor]" 
      var isSafari = /constructor/i.test(window.HTMLElement) || (function(p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

      // Internet Explorer 6-11
      var isIE = /*@cc_on!@*/false || !!document.documentMode;

      // Edge 20+
      var isEdge = !isIE && !!window.StyleMedia;

      // Chrome 1 - 71
      var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

      if (!isChrome) {
        // Chrome check that works on 106.
        if (navigator.userAgentData?.brands) {
          isChrome = navigator.userAgentData.brands.filter(brand => brand.brand === 'Google Chrome').length > 0;
        }
      }

      // Blink engine detection
      var isBlink = (isChrome || isOpera) && !!window.CSS;


      if (isOpera) {
        browser = 'Opera';
      }
      if (isFirefox) {
        browser = 'Firefox';
      }
      if (isSafari) {
        browser = 'Safari';
      }
      if (isIE) {
        browser = 'Internet Explorer';
      }
      if (isEdge) {
        browser = 'Edge';
      }
      if (isChrome) {
        browser = 'Chrome';
      }


      return {name: browser};
    };
    self.userAgent = $window.navigator.userAgent;
    self.device = {
      name: $window.navigator.userAgent.match(/iPad/i) === "iPad" ? "iPad" : $window.navigator.userAgent.match(/iPhone/i) === "iPhone" ? "iPhone" : $window.navigator.userAgent.match(/Android/i) === "Android" ? "Android" : $window.navigator.userAgent.match(/IEMobile/i) === "IEMobile" ? "WindowsPhone" : $window.navigator.userAgent.match(/BlackBerry/i) === "BlackBerry" ? "BlackBerry" : "Generic",
      isMobile: function() {
        if (
            $window.navigator.userAgent.match(/Android/i)
            || $window.navigator.userAgent.match(/webOS/i)
            || $window.navigator.userAgent.match(/iPhone/i)
            || $window.navigator.userAgent.match(/iPad/i)
            || $window.navigator.userAgent.match(/iPod/i)
            || $window.navigator.userAgent.match(/BlackBerry/i)
            || $window.navigator.userAgent.match(/Windows Phone/i)
            ) {
          return true;
        }
        return false;
      },
      browser: self.getBrowser(),
      pixelRatio: $window.devicePixelRatio || 1.0
    };
    self.imageCdn = {
      baseUrl: 'https://res.cloudinary.com/continu/image/fetch/',
      sharedProps: 'f_auto,q_auto'
    };
    self.colors = {
      get: function() {
        return appConfiguration.colors;
      }
    };

    self.locales = [
      {"name": "Afrikaans", "value": "af"},
      {"name": "Akan", "value": "ak"},
      {"name": "Albanian", "value": "sq"},
      {"name": "Amharic", "value": "am"},
      {"name": "Arabic", "value": "ar"},
      {"name": "Armenian", "value": "hy"},
      {"name": "Aromanian", "value": "rup_MK"},
      {"name": "Assamese", "value": "as"},
      {"name": "Azerbaijani", "value": "az"},
      {"name": "Azerbaijani (Turkey)", "value": "az_TR"},
      {"name": "Bashkir", "value": "ba"},
      {"name": "Basque", "value": "eu"},
      {"name": "Belarusian", "value": "bel"},
      {"name": "Bengali", "value": "bn_BD"},
      {"name": "Bosnian", "value": "bs_BA"},
      {"name": "Bulgarian", "value": "bg_BG"},
      {"name": "Burmese", "value": "my_MM"},
      {"name": "Catalan", "value": "ca"},
      {"name": "Catalan (Balear)", "value": "bal"},
      {"name": "Chinese (China)", "value": "zh_CN"},
      {"name": "Chinese (Hong Kong)", "value": "zh-hk"},
      {"name": "Chinese (Taiwan)", "value": "zh_TW"},
      {"name": "Corsican", "value": "co"},
      {"name": "Croatian", "value": "hr"},
      {"name": "Czech", "value": "cs"},
      {"name": "Czech", "value": "cs_CZ"},
      {"name": "Danish", "value": "da"},
      {"name": "Danish", "value": "da_DK"},
      {"name": "Dhivehi", "value": "dv"},
      {"name": "Dutch", "value": "nl"},
      {"name": "Dutch", "value": "nl_NL"},
      {"name": "Dutch (Belgium)", "value": "nl_BE"},
      {"name": "English", "value": "en_US"},
      {"name": "English (Australia)", "value": "en_AU"},
      {"name": "English (Canada)", "value": "en_CA"},
      {"name": "English (UK)", "value": "en_GB"},
      {"name": "Esperanto", "value": "eo"},
      {"name": "Estonian", "value": "et"},
      {"name": "Faroese", "value": "fo"},
      {"name": "Finnish", "value": "fi"},
      {"name": "French (Belgium)", "value": "fr_BE"},
      {"name": "French (France)", "value": "fr_FR"},
      {"name": "French (Canada)", "value": "fr_CA"},
      {"name": "Frisian", "value": "fy"},
      {"name": "Fulah", "value": "fuc"},
      {"name": "Galician", "value": "gl_ES"},
      {"name": "Georgian", "value": "ka_GE"},
      {"name": "German", "value": "de_DE"},
      {"name": "German (Switzerland)", "value": "de_CH"},
      {"name": "Greek", "value": "el"},
      {"name": "Guaraní", "value": "gn"},
      {"name": "Gujarati", "value": "gu_IN"},
      {"name": "Hawaiian", "value": "haw_US"},
      {"name": "Hazaragi", "value": "haz"},
      {"name": "Hebrew", "value": "he_IL"},
      {"name": "Hindi", "value": "hi_IN"},
      {"name": "Hungarian", "value": "hu_HU"},
      {"name": "Icelandic", "value": "is_IS"},
      {"name": "Ido", "value": "ido"},
      {"name": "Indonesian", "value": "id_ID"},
      {"name": "Irish", "value": "ga"},
      {"name": "Italian", "value": "it_IT"},
      {"name": "Japanese", "value": "ja"},
      {"name": "Javanese", "value": "jv_ID"},
      {"name": "Kannada", "value": "kn"},
      {"name": "Kazakh", "value": "kk"},
      {"name": "Khmer", "value": "km"},
      {"name": "Kinyarwanda", "value": "kin"},
      {"name": "Kirghiz", "value": "ky_KY"},
      {"name": "Korean", "value": "ko_KR"},
      {"name": "Kurdish (Sorani)", "value": "ckb"},
      {"name": "Lao", "value": "lo"},
      {"name": "Latvian", "value": "lv"},
      {"name": "Limburgish", "value": "li"},
      {"name": "Lingala", "value": "lin"},
      {"name": "Lithuanian", "value": "lt_LT"},
      {"name": "Luxembourgish", "value": "lb_LU"},
      {"name": "Macedonian", "value": "mk_MK"},
      {"name": "Malagasy", "value": "mg_MG"},
      {"name": "Malay", "value": "ms_MY"},
      {"name": "Malayalam", "value": "ml_IN"},
      {"name": "Marathi", "value": "mr"},
      {"name": "Mingrelian", "value": "xmf"},
      {"name": "Mongolian", "value": "mn"},
      {"name": "Montenegrin", "value": "me_ME"},
      {"name": "Nepali", "value": "ne_NP"},
      {"name": "Norwegian", "value": "no"},
      {"name": "Norwegian (Bokmål)", "value": "nb_NO"},
      {"name": "Norwegian (Nynorsk)", "value": "nn_NO"},
      {"name": "Oriya", "value": "ory"},
      {"name": "Ossetic", "value": "os"},
      {"name": "Pashto", "value": "ps"},
      {"name": "Persian", "value": "fa_IR"},
      {"name": "Persian (Afghanistan)", "value": "fa_AF"},
      {"name": "Polish", "value": "pl_PL"},
      {"name": "Portuguese (Brazil)", "value": "pt_BR"},
      {"name": "Portuguese (Portugal)", "value": "pt_PT"},
      {"name": "Punjabi", "value": "pa_IN"},
      {"name": "Rohingya", "value": "rhg"},
      {"name": "Romanian", "value": "ro_RO"},
      {"name": "Russian", "value": "ru_RU"},
      {"name": "Russian (Ukraine)", "value": "ru_UA"},
      {"name": "Rusyn", "value": "rue"},
      {"name": "Sakha", "value": "sah"},
      {"name": "Sanskrit", "value": "sa_IN"},
      {"name": "Sardinian", "value": "srd"},
      {"name": "Scottish", "value": "gd"},
      {"name": "Serbian", "value": "sr_RS"},
      {"name": "Sindhi", "value": "sd_PK"},
      {"name": "Sinhala", "value": "si_LK"},
      {"name": "Slovak", "value": "sk_SK"},
      {"name": "Slovenian", "value": "sl_SI"},
      {"name": "Somali", "value": "so_SO"},
      {"name": "South", "value": "azb"},
      {"name": "Spanish (Argentina)", "value": "es_AR"},
      {"name": "Spanish (Chile)", "value": "es_CL"},
      {"name": "Spanish (Colombia)", "value": "es_CO"},
      {"name": "Spanish (Mexico)", "value": "es_MX"},
      {"name": "Spanish (Peru)", "value": "es_PE"},
      {"name": "Spanish (Puerto", "value": "es-pr"},
      {"name": "Spanish (Spain)", "value": "es_ES"},
      {"name": "Spanish (Venezuela)", "value": "es_VE"},
      {"name": "Sundanese", "value": "su_ID"},
      {"name": "Swahili", "value": "sw"},
      {"name": "Swedish", "value": "sv_SE"},
      {"name": "Swiss", "value": "gsw"},
      {"name": "Tagalog", "value": "tl"},
      {"name": "Tajik", "value": "tg"},
      {"name": "Tamazight (Central Atlas)", "value": "tzm"},
      {"name": "Tamil", "value": "ta_IN"},
      {"name": "Tamil (Sri Lanka)", "value": "ta-lk"},
      {"name": "Tatar", "value": "tt_RU"},
      {"name": "Telugu", "value": "te"},
      {"name": "Thai", "value": "th"},
      {"name": "Tibetan", "value": "bo"},
      {"name": "Tigrinya", "value": "tir"},
      {"name": "Turkish", "value": "tr_TR"},
      {"name": "Turkmen", "value": "tuk"},
      {"name": "Uighur", "value": "ug_CN"},
      {"name": "Ukrainian", "value": "uk"},
      {"name": "Urdu", "value": "ur"},
      {"name": "Uzbek", "value": "uz_UZ"},
      {"name": "Vietnamese", "value": "vi"},
      {"name": "Walloon", "value": "wa"},
      {"name": "Welsh", "value": "cy"}
    ];
  
    self.getUserLanguage = () => {
      return window.navigator.userLanguage || window.navigator.language;
    }
    self.getUserLocale = () => {
      //TODO this doesn't properly match "zh-hk", "es-pr", or "ta-lk"
      return self.locales.findIndex(o => o.value.toLowerCase() === self.getUserLanguage().toLowerCase().replace('-','_')) > 0 ? self.getUserLanguage() : 'en';
    }
    self.dateFormatting = {
      initMomentLocale: () => {
        moment.locale(self.getUserLocale());
      },
      options: ['usa', 'australia'],
      getOption: function() {
        var option = Features.flags().date_display;
        if (self.dateFormatting.options.indexOf(option) === -1) {
          return 'usa';
        }
        return option;
      },
      getStandardFormat: function (supplied) {
          //TODO: We should transition to using this, but the scope is outside of the current ticket. It worked well for workshops and is an improvement to date representation
          //var baseFormat = moment.localeData(self.getUserLocale()).longDateFormat('L'); // DD/MM/YYYY or MM/DD/YYYY
          //var convertedFormat = baseFormat.replace('DD', 'dd').replace('YYYY', 'yyyy').replace('MM', 'M'); // dd/M/yyy or M/dd/yyyy
          //return convertedFormat;
          var format = {
            australia: 'dd/M/yyyy',
            usa: 'M/dd/yyyy'
          };
          var option = supplied && self.dateFormatting.options.indexOf(supplied) !== -1 || self.dateFormatting.getOption();
          return format[option] || format.usa;
      },
      getStandardMomentFormat: function (supplied) {
        var format = {
          australia: 'DD/MM/YYYY',
          usa: 'M/D/YYYY'
        };
        var option = supplied && self.dateFormatting.options.indexOf(supplied) !== -1 || self.dateFormatting.getOption();
        return format[option] || format.usa;
      },
      getAngularJSDateFormat: function () {
        // As described here: https://docs.angularjs.org/api/ng/filter/date
        // This is not a perfect mapper!  It gets us close for the specific moment formats
        // likely to come up in "l" forms of long date format locales.
        // Details here: https://momentjscom.readthedocs.io/en/latest/moment/07-customization/06-long-date-formats/
        const momentFormat = self.dateFormatting.getMomentFormat();
        return momentFormat.replace(/D/g, 'd').replace(/Y/g, 'y');
      },
      getMomentFormat: function () {
        return moment.localeData(self.getUserLocale()).longDateFormat('l'); // D/M/YYYY or M/D/YYYY 'LL' for January 1, 2022
      },
      getUniversalDateFormat: function () {
        return 'YYYY-MM-DD'
      },
      getWorkshopPickerFormat: function () {
        var baseFormat = moment.localeData(self.getUserLocale()).longDateFormat('L'); // DD/MM/YYYY or MM/DD/YYYY --- 'LL' for MMMM d, yyyy
         //dd/MM/yyyy or MM/dd/yyyy
        return baseFormat.replace('MM', 'M').replace('DD', 'd').replace('YYYY', 'yyyy');
      }
  };
  //set the global moment locale
  self.dateFormatting.initMomentLocale();
  
  self.tuiBgImage = 'data:image/png;base64,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\n';

    // Every value Application copies out of the config, in one place so the initial object and
    // the post-sign-in refresh below can't drift. `features` is deliberately not here: on
    // Application that key is the Features service, while the config's `features` is the raw
    // flag object, so a blanket extend would replace the service with it.
    var fromConfig = function(config) {
      return {
        API: config.apiUrl,
        ANALYZE: config.analyzeUrl,
        REPORTS: config.reportsUrl,
        RECORDING_DISTRIBUTION: config.recordingDistribution,
        COLORS: config.colors,
        LAYOUT: config.layout,
        CUSTOMFONT: config.customFont,
        assetCdnUrl: config.cdnUrl,
        publicImageUrl: config.publicImageUrl,
        companyDomain: config.host,
        backgroundInfo: config.backgroundInfo,
        chartColors: config.chartColors,
        customCopy: config.customCopy,
        froalaConfig: config.froalaConfig,
        hubLinks: config.hubLinks,
        registerAllow: config.registerAllow,
        samlCopy: config.samlCopy,
        signinUseNewWindow: config.signinUseNewWindow,
        slackLink: config.slackLink,
        eddySlackLink: config.eddySlackLink,
        supportCenterBrandLocation: config.supportCenterBrandLocation,
        supportEmailAddress: config.supportEmailAddress,
        supportEmailName: config.supportEmailName,
        ticketingBrand: config.ticketingBrand,
        zdKey: config.zdKey,
        zoomLink: config.zoomLink,
        microsoftMeetingsTeamsLink: config.microsoftMeetingsTeamsLink,
        teamsAppTenantAuthLink: config.teamsAppTenantAuthLink,
        teamsAppDelegatedAuthLink: config.teamsAppDelegatedAuthLink,
        microsoftTeamsVersion: config.microsoftTeamsVersion,
        theme: config.theme,
      };
    };

    var application = angular.extend({
      access: Access,
      smartbar: self.smartbar,
      notifications: NotificationService,
      languages: Languages,
      navigation: Navigation,
      trackState: self.trackState,
      storage: Storage,
      categories: self.categories,
      device: self.device,
      imageCdn: self.imageCdn,
      defer: self.defer,
      getBrowser: self.getBrowser,
      userAgent: self.userAgent,
      messaging: Messaging,
      intercom: Intercom,
      scrollTop: self.scrollTop,
      visual: self.visual,
      colors: self.colors,
      Tracking: self.Tracking,
      features: Features,
      locales: self.locales,
      dateFormatting: self.dateFormatting,
      plantrack: $window.plantrack,
      analyticsProvider: AnalyticsProvider,
      showSecrets: !!$location.search().showsecrets,
      tuiBgImage: self.tuiBgImage,
    }, fromConfig(appConfiguration));
    // The values above are copied, so re-read them when the signed-in half lands after boot.
    // `appConfiguration` has already been extended by then, so it carries both halves.
    $rootScope.$on('companyConfiguration:loaded', function() {
      angular.extend(application, fromConfig(appConfiguration));
    });
    return application;
  }]);
